import styled from 'styled-components';

/**
 * A round button below the cameras by the orientation cube, dark and slightly translucent as the panel with the
 * cameras, in the brand's yellow while active.
 */
const RoundButton = styled.button<{ $active?: boolean }>`
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  color: ${(props) => (props.$active ? props.theme.color.brand.dark : '#fff')};
  background-color: color-mix(
    in srgb,
    ${(props) => props.theme.color.gray.darkest} 80%,
    transparent
  );
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3);

  &:hover {
    background-color: ${(props) => props.theme.color.gray.darkest};
  }
`;

export { RoundButton };
